function Denmark({ dimensions }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1048)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M12.5219 13.9131H31.8647C30.842 6.06262 24.1293 0 16.0001 0C14.8054 0 13.6419 0.132063 12.5219 0.380313V13.9131H12.5219Z" fill="#D80027"/>
  <path d="M8.34787 13.9129V1.94531C3.95456 4.34244 0.809435 8.73938 0.135498 13.9129H8.34787V13.9129Z" fill="#D80027"/>
  <path d="M8.3478 18.0879H0.135498C0.809435 23.2615 3.95456 27.6584 8.34787 30.0555L8.3478 18.0879Z" fill="#D80027"/>
  <path d="M12.5219 18.088V31.6206C13.6419 31.8689 14.8054 32.001 16.0001 32.001C24.1293 32.001 30.842 25.9383 31.8647 18.0879H12.5219V18.088Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Denmark;
